import { render, staticRenderFns } from "./WarehouseGroceryPlaceholder.vue?vue&type=template&id=6dfcbadd&scoped=true"
import script from "./WarehouseGroceryPlaceholder.vue?vue&type=script&lang=js"
export * from "./WarehouseGroceryPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./WarehouseGroceryPlaceholder.vue?vue&type=style&index=0&id=6dfcbadd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfcbadd",
  null
  
)

export default component.exports